<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <div style="height: 100%;">
        <div style="height: 50px">
<!--          <el-select v-fixZoom-->
<!--            v-model="selectUserID"-->
<!--            filterable-->
<!--            placeholder="查找"-->
<!--            style="margin-right: 10px; width:200px;" >-->
<!--            <el-option v-for="item in userListOptions"-->
<!--                       :key="item.userid"-->
<!--                       :label="item.name"-->
<!--                       :value="item.userid">-->
<!--            </el-option>-->
<!--          </el-select>-->
          <el-date-picker v-fixZoom
            :clearable="false"
            v-model="userDate"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="userDatePickerOptions"
            style="margin-right: 10px; width: 400px">
          </el-date-picker>&nbsp;&nbsp;
          <el-button type="primary" @click="getSipOnline()">查询</el-button>
        </div>
        <div style="max-height: calc(100% - 100px);overflow-y: auto;">
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
              type="index"
              label="序号"
              width="70"
              align="center">
            </el-table-column>
            <el-table-column
              prop="syspersonname"
              label="客服姓名"
              min-width="80"
              align="center">
            </el-table-column>
            <el-table-column
              label="SIP电话"
              min-width="90"
              align="center">
              <template slot-scope="scope">
                <span>{{phoneType(scope.row.sipid)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="onlinetime"
              label="上线时间"
              min-width="80"
              align="center">
            </el-table-column>
            <el-table-column
              label="下线时间"
              min-width="80"
              align="center">
              <template slot-scope="scope">
                <span>{{offlinetime(scope.row.offlinetime)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 10px;height: 40px;text-align: center">
          <el-pagination v-fixZoom
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCells">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {querysiponline} from '../../api/seatonline'
import {querysip} from '../../api/sipPhone'
export default {
  name: 'seatsOnline',
  data () {
    return {
      userListOptions: [],
      selectUserID: '',
      userDate: [],
      userDatePickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近30天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      tableData: [],
      showTable: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      siplist: []
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyy-MM-dd')
    this.userDate = [date + ' 00:00:00', date + ' 23:59:59']
    this.sipPhoneData()
  },
  mounted () {
  },
  methods: {
    sipPhoneData () {
      querysip().then(res => {
        this.siplist = res.data.orgsips
        this.getSipOnline()
      }).catch(() => {})
    },
    getSipOnline () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        from: this.userDate[0],
        to: this.userDate[1]
      }
      querysiponline(params, data).then(res => {
        this.tableData = res.data.siponline
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    phoneType (id) {
      for (let i = 0; i < this.siplist.length; i++) {
        if (parseInt(id) === parseInt(this.siplist[i].id)) {
          return this.siplist[i].sip_username
        }
      }
    },
    offlinetime (time) {
      if (time !== '0000-00-00 00:00:00') {
        return time
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSipOnline()
      // this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSipOnline()
      // this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticalform/seatsOnline.vue